export const getConsultationQuery = `
  query GetConsultation($input: GetConsultationInputType!) {
    getConsultation(input: $input) {
      id
      status
      period {
        start
        end
      }
      recordings {
        id
        status
        duration
      }
      transcriptions {
        id
        recordingId
        content
        type
        isSummarized
      }
      reports {
        id
        createdAt
        content
        specialty
        editedContent
        customSpecialty
        customPrompt {
          id
          title
        }
      }
      exams {
        id
        status
        content
      }
      patient {
        id
        name {
          givenName
        }
      }
      healthcareProfessional {
        id
        name {
          givenName
        }
      }
      healthcareProvider {
        id
        name
        description
        isActive
      }
    }
  }
`

export const getConsultationStatusQuery = `
  query GetConsultation($input: GetConsultationInputType!) {
    getConsultation(input: $input) {
      id
      status
    }
  }
`

export const getConsultationsQuery = `
  query SearchConsultations($input: SearchConsultationsInputType!) {
    searchConsultations(input: $input) {
      totalItems
      totalPages
      currentPage
      items {
        id
        status
        period {
          start
          end
        }
        patient {
          id
          name {
            givenName
          }
        }
        recordings {
          id
          status
          duration
        }
        reports {
          id
        }
      }
    }
  }
`

export const getConsultationReportQuery = `
  query GetConsultationReport($input: GetReportInputType!) {
    getConsultationReport(input: $input) {
      content
    }
  }
`

export const scheduleConsultationMutation = `
  mutation ScheduleConsultation($input: ScheduleConsultationInputType!) {
    scheduleConsultation(input: $input) {
      id
    }
  }
`

export const startConsultationRecordingMutation = `
  mutation StartConsultationRecording($input: StartConsultationRecordingInputType!) {
    startConsultationRecording(input: $input) {
      id
      status
    }
  }
`

export const requestConsultationReportMutation = `
  mutation RequestConsultationReport($input: RequestConsultationReportInputType!) {
    requestConsultationReport(input: $input) {
      id
    }
  }
`

export const getSpecialtyModelsQuery = `
  query GetConsultationReportSpecialtiesAvailable {
    getConsultationReportSpecialtiesAvailable
  }
`

export const cancelConsultationMutation = `
  mutation CancelConsultation($input: CancelConsultationInputType!) {
    cancelConsultation(input: $input) {
      id
    }
  }
`

export const editConsultationReportMutation = `
  mutation EditConsultationReport($input: EditConsultationReportInputType!) {
    editConsultationReport(input: $input) {
      id
    }
  }
`

export const finishConsultationRecordingMutation = `
  mutation FinishConsultationRecording($input: FinishConsultationRecordingInputType!) {
    finishConsultationRecording(input: $input) {
      id
      status
    }
  }
`
